import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-complete-course-manually-modal',
  standalone: false,
  templateUrl: './complete-course-manually-modal.component.html',
  styleUrl: './complete-course-manually-modal.component.scss',
})
export class CompleteCourseManuallyModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input() isCompliance: boolean = false;

  @Output() submit = new EventEmitter();

  dismiss = () => {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  };

  onSubmit = () => {
    this.submit.emit();
  };
}
